import { render, staticRenderFns } from "./changepwd.html?vue&type=template&id=323485a2&scoped=true&"
import script from "./changepwd.js?vue&type=script&lang=js&"
export * from "./changepwd.js?vue&type=script&lang=js&"
import style0 from "./changepwd.sass?vue&type=style&index=0&id=323485a2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323485a2",
  null
  
)

component.options.__file = "changepwd.vue"
export default component.exports